import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';
import { IToastr } from '../types/toastr';

declare const swal: any;
declare const toastr: IToastr;

@Injectable()
export class AlertService {

  toast: IToastr = toastr;

  constructor() { }

  /**
   * Confirmation alert
   *
   * @param text
   * @param title
   */
  confirm(text, title = 'Confirm'): Promise<boolean> {
    const swalConfig = ConstantsService.getSwalConfig(title, text);

    return new Promise(resolve => swal(swalConfig, (result) => resolve(result)));
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/alert.service.ts